import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import {
  EmailResource,
  emailEndpoint$,
  ExternalInvitationEmail,
  HTTP_REQUEST_HEADERS,
  RequestNewUserEmail,
} from '../models/email.model.common';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class EmailApiService implements OnDestroy {
  private emailEndpoint: string;
  private destroyed$: Subject<boolean> = new Subject();

  constructor(private http: HttpClient) {
    emailEndpoint$.pipe(takeUntil(this.destroyed$)).subscribe((baseEndpoint: string) => {
      this.emailEndpoint = `${baseEndpoint}/v1/email/`;
    });
  }

  public sendEmail(emailMessage: EmailResource): Observable<void> {
    return this.http.post<void>(this.emailEndpoint, emailMessage, {
      headers: HTTP_REQUEST_HEADERS,
    });
  }

  public sendExternalInvitationEmail(invitationEmail: ExternalInvitationEmail) {
    return this.sendEmail(invitationEmail);
  }

  public sendRequestNewUserEmail(requestNewUserEmail: RequestNewUserEmail) {
    return this.sendEmail(requestNewUserEmail);
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
